import styled from 'styled-components'
import { H4 } from '../common/H4'

export const H4PrimaryTextColour = styled(H4)`
  color: ${(props) => props.theme.primaryTextColour};
  display: inline-block;
  margin: 0 auto;
`
